export const storeLocator = {
    partnerStores: "storeLocator.partnerStores",
    eccoStore: "storeLocator.eccoStore",
    partnerStore: "storeLocator.partnerStore",
    hoursNotAvailable: "storeLocator.hoursNotAvailable",
    hoursNotAvailableExtended: "storeLocator.hoursNotAvailableExtended",
    parcelLocker: "storeLocator.parcelLocker",
    ariaLabels: {
        loadingToggleAria: "storeLocator.loadingToggleAria",
    },
};
